import { Injectable, EventEmitter } from '@angular/core';
import { Http, Headers } from '@angular/http';
import * as Entities from '../data/Entities';

import 'rxjs/add/operator/toPromise';
import { BehaviorSubject } from 'rxjs';

declare var appConfig: any;
declare var jQuery: any;

@Injectable()
export class SiteServices {
    public static session: Entities.Session;
    public static dict: Object = {};
    public static appConfig = appConfig;

    public onError: EventEmitter<string> = new EventEmitter();
    private headers: Headers;
    public inProgress: boolean;

    public _session: Entities.Session;
    isError = false;
    self: SiteServices;
    public Tag: number;

    public onChangeDetail = new BehaviorSubject(null); //bármilyen detail

    constructor(
        private http: Http // private dialogService: DialogService
    ) {
        const token = sessionStorage.getItem('jwtToken');
        
        this.self = this;
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Authorization', 'Bearer ' + token);
        
        if (SiteServices.session == null) {
            SiteServices.session = new Entities.Session();
        }
        this._session = SiteServices.session;

        if (SiteServices.session.ProviderList.length === 0) {
            this.provider_GetAll({ ProviderCode: 'PROVIDER' }, (data) => {
                SiteServices.session.ProviderList = data.TagObject;
            });
        }
    }

    protected handleErrorPromise(_err: any): string {
        let err: any;

        try {
            err = JSON.parse(_err._body);
        } catch (e) {
            err = _err;
        }

        let errMsg = 'unknown server error';

        if (err) {
            if (err.error) {
                errMsg = err.error;
            } else {
                errMsg = err.errorMessage
                    ? err.errorMessage
                    : err.message
                    ? err.message
                    : err._body
                    ? err._body
                    : err.status
                    ? `${err.status} - ${err.statusText}`
                    : 'unknown server error';
            }
        }

        return errMsg;

        // this = null !!!!!!!
        // self.error(errMsg);
        // return Promise.reject(errMsg);
    }

    public post(
        controller: string,
        method: string,
        postData: any,
        clbFunc: Function
    ) {
        this.inProgress = true;
        this.clearmsg();
        this.http
            .post(
                '/' + controller + '/' + method + '/',
                JSON.stringify(postData),
                { headers: this.headers }
            )
            .toPromise()
            .then((data) => {
                this.inProgress = false;

                const retobj = JSON.parse(data.text());
                if (retobj.ErrorTxt) {
                    if (retobj.ErrorCode === 'ExpiredToken') {
                        window.location.href = '/auth/login';
                    }

                    this.error(retobj.ErrorTxt);
                    return;
                }

                if (clbFunc) clbFunc(retobj);
            })
            .catch((err) => {
                this.inProgress = false;
                const ex = this.handleErrorPromise(err);
                this.error(ex);
            });
    }

    public get(controller: string, method: string, clbFunc: Function) {
        this.inProgress = true;
        this.clearmsg();
        this.http
            .get('/' + controller + '/' + method, { headers: this.headers })
            .toPromise()
            .then((data) => {
                this.inProgress = false;

                const retobj = JSON.parse(data.text());
                if (retobj.ErrorTxt) {
                    if (retobj.ErrorCode == 'ExpiredToken') {
                        window.location.href = '/auth/login';
                    }

                    this.error(retobj.ErrorTxt);
                    return;
                }

                if (clbFunc) clbFunc(retobj);
            })
            .catch((err) => {
                this.inProgress = true;
                const ex = this.handleErrorPromise(err);
                this.error(ex);
            });
    }

    public clearmsg() {
        const $msg = jQuery('.plhMessage2');
        $msg.hide();
    }

    public warning(message: string, timeout?: number) {
        const thisobj = this;
        const $msg = jQuery('.plhMessage2');
        const offset = jQuery(document.activeElement).offset();
        $msg.css('position', 'absolute');
        const y = 0;
        $msg.offset({ top: y, left: 0 });

        thisobj.isError = false;
        $msg.find('.msg-content').html(message);
        $msg.removeClass('alert-danger');
        $msg.removeClass('alert-success');
        $msg.addClass('alert-warning');
        $msg.show();

        if (timeout > 0) {
            $msg.hide();
        } else {
            setTimeout(function () {
                $msg.hide();
            }, 2500);
        }

        jQuery('[data-hide]')
            .off('click')
            .on('click', function () {
                jQuery(this)
                    .closest('.' + jQuery(this).attr('data-hide'))
                    .hide();
            });
    }

    public success(message: string, timeout?: number) {
        const thisobj = this;
        const $msg = jQuery('.plhMessage2');
        const offset = jQuery(document.activeElement).offset();
        $msg.css('position', 'absolute');
        let y = 0; // offset.top - 10; if (y < 0) y = 0;
        $msg.offset({ top: y, left: 0 });

        thisobj.isError = false;
        $msg.find('.msg-content').html(message);
        $msg.removeClass('alert-danger');
        $msg.removeClass('alert-warning');
        $msg.addClass('alert-success');
        $msg.show();

        if (timeout > 0) {
            $msg.hide();
        } else {
            setTimeout(function () {
                $msg.hide();
            }, 2500);
        }

        jQuery('[data-hide]')
            .off('click')
            .on('click', function () {
                jQuery(this)
                    .closest('.' + jQuery(this).attr('data-hide'))
                    .hide();
            });
    }

    public error(message: string, timeout?: number) {
        this.onError.emit(message);

        const thisobj = this;
        const $msg = jQuery('.plhMessage2');

        thisobj.isError = true;
        $msg.find('.msg-content').html(message);
        $msg.removeClass('alert-success');
        $msg.removeClass('alert-warning');
        $msg.addClass('alert-danger');
        $msg.show();

        // window.scrollTo(0, 0);

        jQuery('[data-hide]')
            .off('click')
            .on('click', function () {
                jQuery(this)
                    .closest('.' + jQuery(this).attr('data-hide'))
                    .hide();
            });

        if (timeout > 0) {
            $msg.fadeOut(timeout);
        }
    }

    formatdate(dt) {
        try {
            if (
                dt == null ||
                typeof dt === 'string' ||
                dt.toString() === 'Invalid Date'
            ) {
                return '';
            }
            if (dt) {
                if (appConfig.language == 'hu') {
                    return (
                        dt.getFullYear() +
                        '.' +
                        ('0' + (dt.getMonth() + 1)).slice(-2) +
                        '.' +
                        ('0' + dt.getDate()).slice(-2)
                    );
                } else {
                    return (
                        ('0' + dt.getDate()).slice(-2) +
                        '/' +
                        ('0' + (dt.getMonth() + 1)).slice(-2) +
                        '/' +
                        dt.getFullYear()
                    );
                }
            } else return '';
        } catch (ex) {
            return '';
        }
    }

    public sort(
        source: Array<any>,
        filter: any,
        sortField: any,
        isAsc: any
    ): Array<any> {
        if (!sortField) return source;
        return source.sort((n1, n2) => {
            if (
                n1[sortField] > n2[sortField] ||
                (n1[sortField] && !n2[sortField])
            ) {
                return isAsc ? 1 : -1;
            }

            if (
                n1[sortField] < n2[sortField] ||
                (!n1[sortField] && n2[sortField])
            ) {
                return isAsc ? -1 : 1;
            }

            return 0;
        });
    }

    public shopName(shopID: any) {
        if (!shopID) return null;

        var p = SiteServices.session.ProviderList.filter(
            (x) => x.ProviderID == shopID
        )[0];
        if (p) return p.ProviderName;
        else
            return (
                'Hoppá nincs providerId, keress fel egy fejlesztőt! ' + shopID
            );
    }

    public delete(source: Array<any>, finderPredicate: any) {
        var ndx = source.findIndex(finderPredicate);
        if (ndx >= 0) source.splice(ndx, 1);
    }

    public provider_GetPage(providerContext: any, clbFunc: Function) {
        this.post('provider', 'getpage', providerContext, clbFunc);
    }

    public provider_GetAll(providerContext: any, clbFunc: Function) {
        this.post('provider', 'getall', providerContext, clbFunc);
    }

    public provider_GetProvPage(
        pcodeList: string[],
        onlyAvailable: boolean,
        categoryIdList: number[],
        ProdProvsToShow: number,
        clbFunc: Function
    ) {
        this.post(
            'provider',
            'GetProvPage',
            {
                pcodeList: pcodeList,
                onlyAvailable: onlyAvailable,
                categoryIdList: categoryIdList,
                ProdProvsToShow: ProdProvsToShow,
            },
            clbFunc
        );
    }

    public provider_GetDataByID(
        pcode: string,
        key: string,
        tag: string,
        clbFunc: Function
    ) {
        this.get(
            'provider',
            'getdatabyid/' + pcode + '/' + key + '/' + (tag || ''),
            clbFunc
        );
    }

    public provider_GetProvDataByID(
        pcode: string,
        key: string,
        tag: string,
        clbFunc: Function
    ) {
        this.get(
            'provider',
            'getprovdatabyid/' + pcode + '/' + key + '/' + (tag || ''),
            clbFunc
        );
    }

    public provider_GetMissingSimilarProviderProducts(
        pcode: string,
        key: string,
        filterWords: string,
        tag: string,
        clbFunc: Function
    ) {
        this.get(
            'provider',
            'getMissingSimilarProviderProducts/' +
                pcode +
                '/' +
                key +
                '/' +
                filterWords +
                '/' +
                (tag || ''),
            clbFunc
        );
    }

    public provider_GetMissingSimilarProducts(
        pcode: string,
        key: string,
        filterWords: string,
        tag: string,
        clbFunc: Function
    ) {
        this.get(
            'provider',
            'getMissingSimilarProducts/' +
                pcode +
                '/' +
                key +
                '/' +
                filterWords +
                '/' +
                (tag || ''),
            clbFunc
        );
    }

    public provider_Save(pcode: string, objecdata: any, clbFunc: Function) {
        this.post(
            'provider',
            'save',
            { pcode: pcode, pobject: JSON.stringify(objecdata) },
            clbFunc
        );
    }

    public provider_changeStatus(
        pcode: string,
        objecdata: any,
        clbFunc: Function
    ) {
        this.post(
            'provider',
            'status',
            { pcode: pcode, pobject: JSON.stringify(objecdata) },
            clbFunc
        );
    }

    public provider_Delete(pcode: string, objecdata: any, clbFunc: Function) {
        this.post(
            'provider',
            'delete',
            { pcode: pcode, pobject: JSON.stringify(objecdata) },
            clbFunc
        );
    }

    //
    public provider_Update(pcode: string, objecdata: any, clbFunc: Function) {
        this.post(
            'provider',
            'update',
            { pcode: pcode, pobject: JSON.stringify(objecdata) },
            clbFunc
        );
    }
    //

    public provider_Execute(
        pcode: string,
        method: string,
        objecdata: any,
        clbFunc: Function
    ) {
        const res = {
            ProviderCode: pcode,
            Method: method,
            Param: JSON.stringify(objecdata),
        };
        //Object.assign(res, objecdata); --- felesleges
        this.post('provider', 'executecommand', res, clbFunc);
        // console.log(res);
    }

    public provider_ExecuteCrawler(
        pcode: string,
        method: string,
        objecdata: any,
        clbFunc: Function
    ) {
        const res = {
            ProviderCode: pcode,
            Method: method,
            Param: JSON.stringify(objecdata),
        };
        Object.assign(res, objecdata);
        this.post('provider', 'ExecuteCrawlerCommand', res, clbFunc);
    }

    //Elérhetőség
    public provider_ChangeAvailability(
        pcode: string,
        method: string,
        objecdata: any,
        clbFunc: Function
    ) {
        const res = {
            ProviderCode: pcode,
            Method: method,
            Param: JSON.stringify(objecdata),
        };
        Object.assign(res);
        this.post('provider', 'ChangeAvailability', res, clbFunc);
    }

    public provider_ChangeRokshDelivery(
        pcode: string,
        method: string,
        objecdata: any,
        clbFunc: Function
    ) {
        const res = {
            ProviderCode: pcode,
            Method: method,
            Param: JSON.stringify(objecdata),
        };
        Object.assign(res, objecdata);
        this.post('provider', 'ChangeRokshDelivery', res, clbFunc);
    }

    public correction_Execute(
        pcode: string,
        method: string,
        objecdata: any,
        clbFunc: Function
    ) {
        const res = {
            ProviderCode: pcode,
            Method: method,
            Param: JSON.stringify(objecdata),
        };
        Object.assign(res, objecdata);
        //this.post("correction", "ExecuteCorrectionCommand", res, clbFunc);
        this.post('correction', 'ExecuteCommand', res, clbFunc);
    }

    public correction_Execute_userid(
        pcode: string,
        method: string,
        objecdata: any,
        clbFunc: Function,
        counter: number,
        userId: number,
    ) {
        const res = {
            ProviderCode: pcode,
            Method: method,
            Counter: counter,
            UserId: userId,
            Param: JSON.stringify(objecdata),
        };
        Object.assign(res, objecdata);
        //this.post("correction", "ExecuteCorrectionCommand", res, clbFunc);
        this.post('correction', 'ExecuteCommand', res, clbFunc);
    }
    
    public archie_Execute(method: string, objectData: any, callbackFunction: Function){
        const request = {
            Method: method,
            Param: JSON.stringify(objectData)
        };
        Object.assign(request, objectData);
        
        this.post('archie', 'ExecuteCommand', request, callbackFunction);
    }
}
